// extracted by mini-css-extract-plugin
module.exports = {"button":"CloseButton_button__ggVb4","span":"CloseButton_span__zHxLk"};